import { media, styled } from '@styles';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: -10px;
  ${media.xLargeScreen`
    margin-top: -9px;
  `}
  ${media.largeScreen`
    margin-top: -6px;
  `}
  ${media.mediumScreen`
    margin-top: 0px;
    margin-bottom: 10px;
  `}
  ${media.smallScreen`
    justify-content: center;
  `}
`;

export const Button = styled.button`
  padding: 5px 30px;
  background: ${({ theme: { colors } }) => colors.light};
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  ${media.smMediumScreen`
    width: 100%;
  `}

  .arrow-icon {
    position: relative;
    top: -1px;
    -webkit-transition: -webkit-transform 0.3s ease;
    transition: -webkit-transform 0.3s ease;
    transition: transform 0.3s ease;
    transition: transform 0.3s ease, -webkit-transform 0.3s ease;
    vertical-align: middle;
    g {
      stroke: ${({ theme: { colors } }) => colors.primary};
    }
  }

  .arrow-icon--circle {
    transition: stroke-dashoffset 0.3s ease;
    stroke-dasharray: 95;
    stroke-dashoffset: 95;
  }

  &:hover {
    .arrow-icon {
      transform: translate3d(5px, 0, 0);
    }

    .arrow-icon--circle {
      stroke-dashoffset: 0;
    }
  }
`;

export const Text = styled.span`
  font-family: ${(props) => props.theme.typography.labelFontSize};
  color: ${({ theme: { colors } }) => colors.baseFont};
  opacity: 0.5;
  p {
    line-height: 100%;
  }
  strong {
    color: ${(props) => props.theme.colors.primary};
  }
  em {
    color: ${(props) => props.theme.colors.secondary};
  }
`;

export const Icon = styled.div`
  svg {
    width: ${(props) => props.theme.typography.labelFontSize};
    height: ${(props) => props.theme.typography.labelFontSize};
  }
`;
